import { useState } from "react";
import { Percent } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, CATEGORIES, STORES } from "@/lib/api";

const sel = "rounded-lg border border-[#E2D7C3] bg-white px-3 py-2 text-sm";

export default function BulkPrice({ onDone }) {
  const [category, setCategory] = useState("");
  const [store, setStore] = useState("");
  const [percent, setPercent] = useState("");
  const [busy, setBusy] = useState(false);

  const apply = async () => {
    const pct = parseFloat(percent);
    if (!pct) return toast.error("Enter a percentage, e.g. 10 or -5");
    const body = { category: category || null, store: store || null, percent: pct };
    setBusy(true);
    try {
      const { data: { count } } = await api.post("/admin/products/bulk-price/preview", body);
      const scope = !category && !store ? "EVERY product in the shop" : [category || "all categories", store || "all stores"].join(", ");
      if (!count) return toast.error("No products match");
      if (!window.confirm(`${pct > 0 ? "Raise" : "Lower"} prices by ${Math.abs(pct)}% for ${count} products (${scope})?`)) return;
      const { data } = await api.post("/admin/products/bulk-price", body);
      toast.success(`Updated ${data.updated} prices`);
      setPercent("");
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="mt-4 rounded-2xl bg-white border border-[#EDE4D3] p-5" data-testid="bulk-price-card">
      <p className="font-semibold flex items-center gap-2"><Percent className="w-4 h-4 text-[#8C2220]" /> Bulk price change</p>
      <p className="text-sm text-slate-500 mt-1">Raise (e.g. 10) or lower (e.g. -10) every price in a category by a percentage.</p>
      <div className="mt-3 flex flex-wrap gap-2 items-center">
        <select value={category} onChange={(e) => setCategory(e.target.value)} className={sel} data-testid="bulk-price-category"><option value="">All categories</option>{CATEGORIES.map((c) => <option key={c}>{c}</option>)}</select>
        <select value={store} onChange={(e) => setStore(e.target.value)} className={sel} data-testid="bulk-price-store"><option value="">All stores</option>{STORES.map((s) => <option key={s}>{s}</option>)}</select>
        <input type="number" step="0.5" value={percent} onChange={(e) => setPercent(e.target.value)} placeholder="% e.g. 10" className={`${sel} w-28`} data-testid="bulk-price-percent" />
        <button onClick={apply} disabled={busy} className="rounded-full bg-[#1B3626] text-white px-5 py-2 text-sm font-semibold disabled:opacity-60" data-testid="bulk-price-apply">{busy ? "Working…" : "Apply"}</button>
      </div>
    </div>
  );
}
